export function appendDestinationTemplate(id) {
	let fromtext = '<span> from </span>';
	let totext = '<span> to </span>';
	let departtext = '<span class="trip1">Depart</span>';
	let returntext = '< span class = "trip1" > Return < /span>';

	if ($('#moreDestinations').parent().find('.fromLabel').length > 0) {
		fromtext = $('#moreDestinations').parent().find('.fromLabel').html();
	}
	if ($('#moreDestinations').parent().find('.toLabel').length > 0) {
		totext = $('#moreDestinations').parent().find('.toLabel').html();
	}
	if ($('#moreDestinations').parent().find('.departLabel').length > 0) {
		departtext = $('#moreDestinations').parent().find('.departLabel').html();
	}
	if ($('#moreDestinations').parent().find('.returnLabel').length > 0) {
		returntext = $('#moreDestinations').parent().find('.returnLabel').html();
	}
	return `
  <div class="row  new-destination-row mt-2 position-relative flex-wrap-reverse">
	<div class="order-1 col-12 col-lg-3 px-0 focusControl">
		<div class="align-items-center row mx-0">
			<div class="input-group-prepend">
			<img src="${themeURL}/images/from.svg" />
			</div>
			<input
			type="search"
			name="departureFrom-${id}"
			id="DepartureFrom-${id}"
			class="form-control outline airportInput h-100"
			placeholder=""
			data-emo-custom="needed"
			/>
			<label for="" class="floatingLabel" for="DepartureFrom-${id}">
			${fromtext}
			</label>
			<div class="messages"></div>
			<div class="switchDestinations d-flex">
			<img src="${themeURL}/images/swap_desktop.svg" />
			</div>
		</div>
	</div>
  <div class="order-2 col-12 col-lg-3 px-0 focusControl">
	 <div class="align-items-center row mx-0">
		<div class="input-group-prepend">
		   <img src="${themeURL}/images/to.svg" />
		</div>
		<input
		   type="search"
		   name="departureTo-${id}"
		   id="DepartureTo-${id}"
		   class="form-control outline airportInput h-100"
		   placeholder=""
		   data-emo-custom="needed"
		   />
		<label for="" class="floatingLabel" for="DepartureTo-${id}">
		${totext}
		</label>
		<div class="messages"></div>
	 </div>
  </div>
  <div class="order-4 col col-lg-3 px-0 pointer">
	 <div class="customDatePicker h-100" id="DepartureDate-${id}">
		<div class="d-flex h-100 justify-content-center">
		   <div class="d-flex flex-column pl-3 h-100 justify-content-around">
			  <span class='trip'>${departtext}</span>
			  <div>
				 <span class="departDateValue departDateValue-${id} mr-2">

				 </span>
			  </div>
			</div>
			<div class="returnJunk d-flex flex-column pl-3 h-100 justify-content-around d-none">
				<span class ='trip'> ${returntext} </span>
				<div>
					<span class="arriveDateValue arriveDateValue-${id} mr-2">

					</span>
				</div>
		   </div>
		</div>
	 </div>
	 <input
	 type="text"
	 class="form-control datePicker datePicker-${id}"
	 placeholder="Departure Date"
	 name="date-${id}"
	 data-emo-custom="needed"
	 autocomplete="off"
	 />
  </div>
  <div class="align-items-center col-1 d-flex deleteRow h-100 justify-content-center">
	<svg width="512" height="512" viewBox="0 0 512 512" fill="none" xmlns="http://www.w3.org/2000/svg">
		<path d="M512 60.333L451.667 0L255.999 195.666L60.333 0L0 60.333L195.666 255.999L0 451.667L60.333 512L255.999 316.334L451.666 512L511.999 451.667L316.334 255.999L512 60.333Z" fill="black"/>
	</svg>
  </div>
</div>
  `
}

export default appendDestinationTemplate
